import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  Container,
  Paper,
  Typography,
  Box,
  Button
} from '@mui/material'
import {
  CheckCircle as SuccessIcon,
  Home as HomeIcon,
  Visibility as ViewIcon
} from '@mui/icons-material'

const PaymentSuccess = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { payment, propertyId, planName } = location.state || {}

  const handleGoToProperty = () => {
    if (propertyId) {
      navigate(`/property/${propertyId}`)
    } else {
      navigate('/')
    }
  }

  const handleGoToHome = () => {
    navigate('/')
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          background: 'linear-gradient(to bottom, #f5f5f5, #ffffff)'
        }}
      >
        {/* Ícone de Sucesso */}
        <Box
          sx={{
            display: 'inline-flex',
            p: 3,
            borderRadius: '50%',
            bgcolor: 'success.light',
            mb: 3
          }}
        >
          <SuccessIcon sx={{ fontSize: 80, color: 'success.dark' }} />
        </Box>

        {/* Título */}
        <Typography variant="h4" fontWeight={700} color="success.dark" gutterBottom>
          Pagamento Confirmado!
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Seu impulsionamento foi ativado com sucesso
        </Typography>

        {/* Detalhes */}
        <Paper variant="outlined" sx={{ p: 3, mb: 4, bgcolor: 'white' }}>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            <strong>Plano:</strong> {planName || 'Impulsionamento'}
          </Typography>
          {payment && (
            <>
              <Typography variant="body1" color="text.secondary" gutterBottom>
                <strong>Valor:</strong> R$ {parseFloat(payment.amount).toFixed(2)}
              </Typography>
              <Typography variant="body1" color="text.secondary" gutterBottom>
                <strong>Método:</strong> {payment.payment_method_display || 'PIX'}
              </Typography>
              {payment.confirmed_date && (
                <Typography variant="body1" color="text.secondary">
                  <strong>Data:</strong>{' '}
                  {new Date(payment.confirmed_date).toLocaleString('pt-BR')}
                </Typography>
              )}
            </>
          )}
        </Paper>

        {/* Informações */}
        <Box sx={{ mb: 4, textAlign: 'left' }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            O que acontece agora?
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            ✓ Seu anúncio já está em destaque nas buscas
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            ✓ Seu imóvel terá mais visibilidade
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            ✓ Maior chance de encontrar interessados
          </Typography>
          {payment?.boost?.end_date && (
            <Typography variant="body2" color="text.secondary">
              ✓ Impulsionamento ativo até{' '}
              {new Date(payment.boost.end_date).toLocaleDateString('pt-BR')}
            </Typography>
          )}
        </Box>

        {/* Botões de Ação */}
        <Box display="flex" flexDirection="column" gap={2}>
          <Button
            variant="contained"
            size="large"
            startIcon={<ViewIcon />}
            onClick={handleGoToProperty}
          >
            Ver Meu Anúncio
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<HomeIcon />}
            onClick={handleGoToHome}
          >
            Voltar para Home
          </Button>
        </Box>

        {/* Nota de Rodapé */}
        <Typography variant="caption" color="text.secondary" sx={{ mt: 4, display: 'block' }}>
          Um comprovante foi enviado para seu email
        </Typography>
      </Paper>
    </Container>
  )
}

export default PaymentSuccess
